import { ChangeHighlighter, FormattedNumberInput } from '@rd-web-markets/shared/dist/util';
import React from 'react';
import { useTranslation } from 'react-i18next';
const TotalTableRow = _ref => {
  let {
    staffCostTotals
  } = _ref;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null, t('total')), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: FormattedNumberInput,
    thousandSeparator: ".",
    decimalSeparator: ",",
    disabled: true,
    object: staffCostTotals,
    name: "gross_wage_total",
    type: "text",
    size: "sm"
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: FormattedNumberInput,
    thousandSeparator: ".",
    decimalSeparator: ",",
    disabled: true,
    object: staffCostTotals,
    name: "b_excluding_special_payments_total",
    type: "text",
    size: "sm"
  })), /*#__PURE__*/React.createElement("td", null));
};
export default TotalTableRow;